import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHead, Badge } from "../components/ui-bits";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";

const CATS = ["Accounting", "GST", "Income Tax", "Payroll", "Legal", "Loan"];

export default function Tickets() {
  const [tickets, setTickets] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ subject: "", category: "GST", description: "" });

  const load = () => api.get("/tickets").then((r) => setTickets(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.subject.trim()) return;
    await api.post("/tickets", form);
    toast.success("Ticket raised successfully");
    setForm({ subject: "", category: "GST", description: "" });
    setOpen(false); load();
  };

  return (
    <div>
      <PageHead eyebrow="Support" title="Tickets">
        <button data-testid="new-ticket-btn" onClick={() => setOpen(!open)}
          className="bg-[#002FA7] hover:bg-[#00227A] text-white px-4 py-2 rounded-sm text-sm flex items-center gap-2 transition-colors">
          <Plus size={16} /> Raise Ticket
        </button>
      </PageHead>

      {open && (
        <form onSubmit={submit} className="card p-6 mb-6 space-y-3 fade-up">
          <input data-testid="ticket-subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}
            placeholder="Subject" className="w-full border border-black/20 rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
          <select data-testid="ticket-category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}
            className="w-full border border-black/20 rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]">
            {CATS.map((c) => <option key={c}>{c}</option>)}
          </select>
          <textarea data-testid="ticket-desc" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })}
            placeholder="Describe your issue…" rows={3} className="w-full border border-black/20 rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
          <button data-testid="ticket-submit" className="bg-[#002FA7] text-white px-4 py-2 rounded-sm text-sm hover:bg-[#00227A]">Submit</button>
        </form>
      )}

      <div className="card divide-y divide-black/10">
        {tickets.map((t, i) => (
          <div key={i} data-testid={`ticket-${i}`} className="flex items-center gap-4 px-5 py-4">
            <span className="tnum text-xs text-[#888] w-16">{t.id}</span>
            <div className="flex-1">
              <p className="text-sm font-medium">{t.subject}</p>
              <p className="text-xs text-[#888]">{t.category} · {t.raised_by}</p>
            </div>
            <Badge status={t.status} />
          </div>
        ))}
      </div>
    </div>
  );
}
